import Preloader from '../../components/common/preloader'
import { Nullable } from '../../types/common'
import { getTemplateFirstChildContent } from '../../utils/dom'
import Shop from '../shop/shop'
import Sidebar from '../sidebar/sidebar'

class SidebarFilters extends Sidebar {
  form: Nullable<HTMLFormElement>

  constructor() {
    super()

    this.form = this.element.querySelector('[data-filters-form]')
  }

  connectedCallback(): void {
    super.connectedCallback()

    this.form.addEventListener('scroll', this.handleFormScroll)
    this.addEventListener('change', this.handleInputChange)
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback(): void {
    super.disconnectedCallback()

    this.form.removeEventListener('scroll', this.handleFormScroll)
    this.removeEventListener('change', this.handleInputChange)
    this.removeEventListener('click', this.handleClick)
  }

  handleFormScroll = (): void => {
    if (this.form) {
      const isScrolled = this.form.scrollTop > 0

      this.toggleAttribute('header-shadow-visible', isScrolled)
    }
  }

  handleClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const label = target.closest('[data-filters-checkbox]')

    if (label) {
      label.setAttribute('selected', '')
    }
  }

  handleInputChange = (event: InputEvent): void => {
    const target = event.target as HTMLInputElement

    if (target.tagName === 'INPUT') {
      this.change()
    }
  }

  change(): void {
    // re-define in children
  }

  createFilterQuery(): void {
    if (this.form && this.shop) {
      const formData = new FormData(this.form)
      const filterQuery = new URLSearchParams(formData as any).toString()

      this.shop.filterQuery = filterQuery
    }
  }

  updateHTML(html: Document): void {
    if (this.isOpenOnInit) {
      const filterId = this.getAttribute('id')
      const newFilter = filterId ? html.getElementById(filterId) : null
      const newElement = newFilter
        ? newFilter.querySelector('[data-sidebar-body]')
        : null

      if (newElement) {
        this.updateFormFromElement(newElement)
        this.updateHeaderFromElement(newElement)
      }
    } else {
      const filterId = this.getAttribute('id')
      const newFilter = filterId ? html.getElementById(filterId) : null
      const newTemplate = newFilter
        ? newFilter.querySelector(`[data-sidebar-template="${this.id}"]`)
        : null

      if (newTemplate) {
        const newElement = getTemplateFirstChildContent(newTemplate)

        this.updateFormFromElement(newElement)
        this.updateHeaderFromElement(newElement)
      }
    }
  }

  updateHeaderFromElement(newElement: HTMLElement): void {
    const header = this.element.querySelector('[data-filters-header]')
    const newHeader = newElement.querySelector('[data-filters-header]')

    if (header && newHeader) {
      const clonedNewHeader = newHeader.cloneNode(true)

      header.replaceChildren(...clonedNewHeader.childNodes)
    }
  }

  updateFormFromElement(newElement: HTMLElement): void {
    const form = this.element.querySelector('[data-filters-form]')
    const newForm = newElement.querySelector('[data-filters-form]')

    if (form && newForm) {
      const clonedNewForm = newForm.cloneNode(true)

      form.replaceChildren(...clonedNewForm.childNodes)
    }
  }

  get shop(): Nullable<Shop> {
    return this.element.closest('shop-component')
  }

  get searchParams(): string {
    if (!this.shop) {
      return ''
    }

    return [this.shop.filterQuery, this.shop.sortQuery].join('&')
  }

  get loadingOverlay(): Nullable<Preloader> {
    const preloader = this.element.querySelector<HTMLElement>(
      '[data-filters-loading-overlay]',
    )

    if (!preloader) {
      return null
    }

    return new Preloader(preloader)
  }
}

export default SidebarFilters
